import React, { useState, useEffect, useMemo } from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const testimonials = [
    // Slide 1

    {
      id: 7,
      // rating: 5,
      quote: "Building Global Connections and Long-Term Business Partnerships",
      description: "Being part of EFFN gives us the opportunity to connect with freight forwarding professionals from different markets, exchange industry expertise and develop new international partnerships. We value the network as a platform for building trusted business relationships and expanding cooperation across the global logistics industry.",
      name: "Mr. Artjoms Hondozko",
      role: "Managing Director, Lazarus Forwarding, Latvia",
      avatar: "/testimonial05.jpg"
    },

    {
      id: 4,
      // rating: 5,
      quote: "Access to global markets made simple and achievable",
      description: "We have had a very positive experience with the Elite Freight Forwarding Network. The network provides excellent opportunities to connect with reliable freight forwarding partners as it grows across different countries. Their professional approach, ready cooperation, and commitment to facilitating long-term business relationships have added real value to our international operations. We are happy & pleased to be associated with Elite Freight Forwarding Network and look forward to strengthening our partnership further.",
      name: "Mr. Faisal Abbasi",
      role: "General Manager , Silverline TransTrade FZE LLC, UAE",
      avatar: "/testimoinal4.jpeg"
    },

    {
      id: 6,
      // rating: 5,
      quote: "Expanding Global Networks and Creating New Business Opportunities",
      description: "Joining EFFN is an exciting step for BL GLOBAL Logistics in expanding our international network and building new business relationships worldwide. We believe that EFFN provides a valuable platform for connecting with reliable freight forwarding partners, sharing expertise, and exploring new business opportunities. We look forward to developing strong, long-term partnerships with fellow members and creating mutually beneficial cooperation across global markets. We are pleased to be part of this growing international community.",
      name: "Mr. Gorkem ALTINEL",
      role: "Operation Director, BL Global Logistics And More, Turkey",
      avatar: "/testimonial04.jpg"
    },

    {
      id: 2,
      // rating: 5,
      quote: "Connecting with reliable freight forwarding partners worldwide",
      description: "We are pleased to be a member of EFFN. Since joining the network, we have had the opportunity to connect with reliable freight forwarding partners from around the world. The EFFN team has been professional, responsive, and supportive, making it easier to build trusted business relationships. We appreciate the platform and look forward to expanding our cooperation with fellow members and growing together.",
      name: "Md Khorshed Alam",
      role: "Managing Director, Marvel Freight Ltd, Bangladesh",
      avatar: "/testimonial2.jpg"
    },

    {
      id: 5,
      // rating: 5,
      quote: "Professional, reliable, and committed to building strong networking relationships.",
      description: `I am pleased to provide this testimonial for Elite Freight Forwarders Network and the
excellent networking services they have provided to our organization.
Throughout our engagement, their team has communicated and demonstrated
professionalism and a strong commitment to customer satisfaction. They regularly make
follow-ups and connect with the networking members.

Based on our experience, we are satisfied with the quality of Elite Freight Forwarders
Network services and would be happy to recommend Elite Freight Forwarders Network to
organizations looking for a reliable and professional networking solutions provider.
We wish them continued success in their future endeavors.`,
      name: "Mr. Radhakrishnan Kumbroat Veedu",
      role: "BDM, Mass International Logistics Services EST, Saudi Arabia",
      avatar: "/testimonial5.jpeg"
    },

    {
      id: 3,
      // rating: 5,
      quote: "Expanding our global reach with trusted freight partners",
      description: "Amadeus Cargo has just joined EFFN, and our first contacts with fellow members have already shown the kind of network we were looking for: specialized, responsive forwarders who take partnership seriously. As a Brazilian specialist in perishable and temperature-controlled cargo, we expect EFFN to become our main channel for building long-term agent relationships worldwide, and we intend to be the reliable partner members can count on for Brazil.",
      name: "Mr. Rubens Lopes",
      role: "CEO, AMADEUS CARGO LTD, Brazil",
      avatar: "/testimonial03.jpg"
    },

    {
      id: 1,
      // rating: 5,
      quote: "Creating Opportunities Across Continents",
      description: "Since joining EFFN, we've expanded into new markets and developed lasting relationships with reliable logistics partners worldwide.",
      name: "Mr. Suresh Nadar",
      role: "Founder of Unicorn Shipping & Logistics, India",
      avatar: "/testimonial1s.jpeg"
    },


  ];

  const totalSlides = testimonials.length;

  // Auto-play carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % totalSlides);
    }, 8000); // Change slide every 8 seconds

    return () => clearInterval(interval);
  }, [totalSlides]);

  // Memoize dots to prevent re-render flicker
  const dots = useMemo(() => {
    return Array.from({ length: totalSlides }, (_, index) => (
      <button
        key={`dot-${index}`}
        className={`dot ${activeSlide === index ? 'active' : ''}`}
        onClick={() => setActiveSlide(index)}
        aria-label={`Go to testimonial ${index + 1}`}
      />
    ));
  }, [activeSlide, totalSlides]);

  return (
    <section className="testimonials-section">
      <div className="container">
        {/* Section Header */}
        <div className="testimonials-header">
          <p className="testimonials-eyebrow">Member Success Stories</p>
          <h2 className="testimonials-heading">What EFFN Members Say</h2>
          <p className="testimonials-subheading">
            Discover how logistics professionals are growing through trusted partnerships and worldwide network connections.
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="testimonials-carousel-wrapper">
          <div
            className="testimonials-carousel"
            style={{ transform: `translateX(-${activeSlide * 100}%)` }}
          >
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonials-slide">
                <div className="testimonial-card-single">
                  {/* Rating */}
                  {/*                  <div className="testimonial-rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                      </svg>
                    ))}
                    <span className="rating-text">({testimonial.rating}) Rating</span>
                  </div>
 */}
                  {/* Quote */}
                  <blockquote className="testimonial-quote">
                    "{testimonial.quote}"
                  </blockquote>

                  {/* Description */}
                  <p className="testimonial-description">
                    {testimonial.description}
                  </p>

                  {/* Author Info */}
                  <div className="testimonial-author">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="author-avatar"
                    />
                    <div className="author-info">
                      <h4 className="author-name">{testimonial.name}</h4>
                      <p className="author-role">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Slider Dots */}
        <div className="testimonials-dots">
          {dots}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
